module.exports = {
  // JCRing成员页 法语
  JCRing_member: {
    index1: "Santé des membres",
    index2: "Groupes de santé",
    index3: "Membres",
    index4: "Ajouter un groupe",
    index5: "Groupes rejoins",
    index6: "Paramètres d'alerte",
    index7: "Laissez ceux qui se soucient de votre santé se soucier davantage de vous à distance, avec des soins opportuns",
    index8: "Pas encore rejoint de groupes",
    index9: "Centre de messages",
    index10: "Invitez à rejoindre via / téléphone / e-mail / QR code / WeChat",
    
    
    addgroup1: "Nom du groupe",
    addgroup2: "Type de groupe",
    addgroup3: "Veuillez entrer le nom du groupe",
    addgroup4: "Groupe familial",
    addgroup5: "Groupe d'entreprise",
    addgroup6: "Autre groupe",
    addgroup7: "Groupe médical",
    addgroup8: "Groupe scolaire",
    addgroup9: "Confirmer",
    addgroup10: "Annuler",
    addgroup11: "Créer maintenant",
    addgroup12: "Le nom du groupe existe déjà",
    
    
    memberlist1: "Liste des membres",
    memberlist2: "Avoir",
    memberlist3: "Anomalies",
    memberlist4: "Normal",
    memberlist5: "Ajouter un membre",
    memberlist6: "Dissoudre",
    memberlist7: "Aucun membre",
    memberlist8: "Chargement en cours",
    memberlist9: "Dissoudre ce groupe?",
    memberlist10: "Dissous avec succès",
    memberlist11: "Enregistré avec succès",
    memberlist12: "Modifier les informations du groupe",
    memberlist13: "Dissoudre le groupe",
    memberlist14: "Aperçu de la santé",
    memberlist15: "Éléments normaux",
    memberlist16: "Éléments anormaux",
    memberlist17: "Cliquez pour voir",
    memberlist18: "Aucune donnée d'hier",
    memberlist19: "Hier",
    memberlist20: "Envoyé",
    memberlist21: "Invitations au groupe envoyées, en attente de confirmation",
    
    
    updatemember1: "Photo de profil",
    updatemember2: "Changer",
    updatemember3: "Surnom d'origine",
    updatemember4: "Modifier le surnom",
    
    
    healthdata1: "données de santé",
    healthdata2: "données de santé",
    healthdata3: "Dimanche",
    healthdata4: "Lundi",
    healthdata5: "Mardi",
    healthdata6: "Mercredi",
    healthdata7: "Jeudi",
    healthdata8: "Vendredi",
    healthdata9: "Samedi",
    healthdata10: "Fréquence cardiaque",
    healthdata11: "Variabilité de la fréquence cardiaque",
    healthdata12: "Pression systolique",
    healthdata13: "Pression diastolique",
    healthdata14: "Variabilité de la température",
    healthdata15: "Saturation en oxygène",
    healthdata16: "Sommeil",
    healthdata17: "Stress",
    healthdata18: "Cholestérol",
    healthdata19: "Triglycérides",
    healthdata20: "Cholestérol LDL",
    healthdata21: "Cholestérol HDL",
    healthdata22: "Glycémie",
    healthdata23: "Avant les repas",
    healthdata24: "Après les repas",
    healthdata25: "Consommation maximale d'oxygène",
    healthdata26: "Respiration",
    healthdata27: "Pas",
    healthdata28: "Pas",
    healthdata29: "Calories",
    healthdata30: "kcal",
    healthdata31: "Distance",
    healthdata32: "Kilomètres",
    healthdata33: "Rythme",
    healthdata35: "Secondes/kilomètre",
    healthdata36: "Minutes",
    healthdata37: "Chargement des données de santé",
    healthdata38: "Données d'exercice",
    healthdata39: "Alertes",
    healthdata40: "Non autorisé",
    healthdata41: "Modifier les informations du membre",
    healthdata42: "Supprimer le membre",
    healthdata43: "E-mail :",
    healthdata44: "Téléphone :",
    healthdata45: "Supprimer ce membre ?",
    healthdata46: "Les dates futures ne peuvent pas être affichées",
    healthdata47: "Aujourd'hui",
    
    
    
    addmember1: "Inviter des membres",
    addmember2: "Ajouter un compte membre",
    addmember4: "En utilisant les 'comptes membres', vous pouvez consulter les données de santé des membres et définir les plages de données d'alerte pour mieux surveiller leur santé",
    addmember5: "En savoir plus",
    addmember6: "Membres du groupe de santé",
    addmember7: "Inviter",
    addmember8: "Rejoindre",
    addmember9: "Inviter en scannant le code QR",
    addmember10: "Invitation par WeChat",
    addmember11: "Inviter à rejoindre le groupe en scannant le code QR",
    addmember12: "Inviter à rejoindre le groupe via WeChat",
    addmember13: "Invitation par téléphone/e-mail",
    addmember14: "Inviter à rejoindre le groupe par téléphone/e-mail",
    addmember15: "Invitez les membres à rejoindre pour consulter leur état de santé",
    addmember16: "Envoyer l'invitation",
    addmember17: "Envoyé",
    addmember18: "En attente de confirmation",
    addmember19: "J'ai rejoint",
    addmember20: "Partager maintenant",
    addmember21: "Enregistrer l'image",
    addmember22: "J'ai refusé",
    addmember23: "Je suis parti",
    addmember24: "Le membre est parti",
    addmember25: "Le membre a refusé",
    addmember26: "Le membre a rejoint",
    addmember27: "Autres méthodes d'ajout",
    
    
    code1: "QR Code du groupe",
    code2: "Groupe de gestion de la santé",
    code3: "Ce code QR est valide pendant 5 minutes. Veuillez l'utiliser rapidement.",
    
    
    // invide1: "Invitation au groupe",
    // invide2: "Santé des membres",
    // invide3: "Vous invite à rejoindre le groupe...",
    // invide4: "Rejoindre ce groupe",
    // invide5: "Pour la sécurité de vos données, il est recommandé de vérifier les informations du groupe avant de rejoindre.",
    // invide6: "Après avoir rejoint le groupe, vous autoriserez les abonnés à voir vos données de santé.",
    
    
    sethealthdata1: "Paramètres des données de santé",
    sethealthdata2: "Confirmer",
    sethealthdata3: "Veuillez définir un pseudonyme",
    sethealthdata4: "Tout autoriser",
    sethealthdata5: "Définir un pseudonyme",
    sethealthdata6: "Sauvegarder",
    sethealthdata7: "Veuillez entrer",
    sethealthdata8: "Veuillez télécharger au format image",
    sethealthdata9: "Veuillez définir à la fois le pseudonyme et l'avatar",
    sethealthdata10: "Veuillez définir un avatar",
    sethealthdata11: "La longueur du pseudonyme doit être de 1 à 8 caractères",
    

    setscope1: "Plage de fréquence cardiaque",
    setscope2: "Plage de température",
    setscope3: "Plage de sommeil",
    setscope4: "Plage de fréquence cardiaque fœtale",
    setscope5: "Glycémie avant les repas",
    setscope6: "Glycémie après les repas",
    setscope7: "Plage de saturation en oxygène",
    setscope8: "Acide urique chez les hommes",
    setscope9: "Acide urique chez les femmes",
    setscope10: "Pression systolique",
    setscope11: "Pression diastolique",
    setscope12: "Limite supérieur",
    setscope13: "Limite inférieur",
    setscope14: "Paramètres d'alerte",
    setscope15: "Paramètres enregistrés",
    setscope16: "Limite supérieur",
    setscope17: "Limite inférieur",
    setscope18: "Alerte",
    
    
    onload1: "Cliquez",
    onload2: "Rejoindre le groupe de santé",
    onload3: "Veuillez ouvrir dans le navigateur",
    onload4: "D'accord",
    onload5: "Youhong Santé, Santé intelligente chaque jour",
    onload6: "Téléchargez gratuitement depuis l'App Store",
    onload7: "Télécharger gratuitement",
    onload8: "Lien expiré",
    onload9: "QR code expiré",
    onload10: "Rejoint avec succès",
    
    
    invide1: "Invitation au groupe",
    invide2: "Santé des membres",
    invide3: "Vous invite à rejoindre le groupe...",
    invide4: "Rejoindre ce groupe",
    invide5: "Pour la sécurité de vos données, il est recommandé de vérifier les informations du groupe avant de rejoindre.",
    invide6: "Après avoir rejoint le groupe, vous autoriserez les abonnés à voir vos données de santé.",
    
    
    guide1: "Après être entré dans la santé des membres, vous devez d'abord créer le type de groupe approprié.",
    guide2: "Après avoir créé le groupe, entrez dans le groupe pour voir l'aperçu de la santé des utilisateurs et inviter de nouveaux membres.",
    guide3: "Pour inviter de nouveaux membres dans le groupe, vous pouvez utiliser des méthodes telles que le scan de QR code, WeChat, numéro de téléphone/email. Après que les nouveaux membres ont rejoint le groupe, vous pouvez consulter leurs mises à jour de santé quotidiennes.",
    guide4: "Cliquez pour voir l'aperçu de la santé, où vous pouvez consulter les données de santé des membres et déterminer les conditions normales ou anormales.",
    guide5: "Suivant",
    guide6: "Terminer",
    guide7: "Dépasse la valeur d'avertissement",
    
    invite1: "Inviter par numéro de téléphone/email",
    invite2: "Veuillez entrer le compte",
    invite3: "Veuillez entrer le numéro de téléphone",
    invite4: "Veuillez entrer l'email",
    invite5: "Veuillez entrer un numéro de téléphone valide",
    invite6: "Veuillez entrer un e-mail valide",
    invite7: "Déjà rejoint ce groupe",
    invite8: "Utilisateur inexistant",
    invite9: "Veuillez sélectionner un pays ou une région",
    invite10: "Veuillez entrer des mots-clés de recherche",
    invite11: "Confirmer l'utilisateur",
    invite12: "Les inviter",
    invite13: "Veuillez sélectionner",
  },

  // AI H5页面
  JCRingAI: {
    index: "Bonjour,",
    index1: "Voici vos aperçus hebdomadaires de santé.",
    index2: "Semaine",
    index3: "Mois",
    index4: "Indice de santé",
    index5: "Indice de sommeil",
    index6: "Indice de vitalité",
    index7: "Indice d'équilibre",
    index8: "Jour",
    index9: "An",
    index10: 'Aperçus Hebdomadaires',
    index11: 'Aperçus Mensuels',
    index12: "Voici vos aperçus mensuels de santé.",
    
    sleep: 'Récupération du sommeil',
    sleep1: "Tendance de l'indice de sommeil",
    sleep2: "Tendance de l'indice de sommeil",
    sleep3: "L'indice de sommeil est un indicateur pour évaluer votre santé du sommeil, calculé sur la base de diverses métriques telles que la durée totale du sommeil, l'efficacité du sommeil, le temps pour s'endormir, la fréquence cardiaque pendant le sommeil, les niveaux d'oxygène pendant le sommeil et la variabilité de la fréquence cardiaque (HRV), etc.",
    sleep4: 'Votre indice de sommeil est',
    sleep5: 'Aperçu du sommeil',
    sleep6: 'La durée moyenne du sommeil est',
    sleep7: 'Les stades du sommeil',
    sleep8: 'Durée moyenne',
    sleep9: 'Pourcentage moyen',
    
    sleep11: 'Siestes',
    sleep12: 'Éveillé',
    sleep13: 'REM',
    sleep14: 'Sommeil léger',
    sleep15: 'Sommeil profond',
    sleep16: 'Occupant % de la semaine entière',
    sleep17: 'La durée totale du sommeil est',
    sleep18: "L'efficacité moyenne du sommeil est",
    sleep19: "%, Le temps moyen pour s'endormir est",
    sleep20: 'min',
    sleep21: 'Aperçus sur le sommeil',
   
    sleep22: 'Données sur votre sommeil améliorées',
    sleep23: 'Indice de sommeil',
    sleep24: 'Comparé à la semaine dernière',
    sleep25: "L'indice moyen de sommeil mensuel est",
    sleep26: 'Durée du sommeil',
    sleep27: "Temps pour s'endormir",
    sleep28: "Temps moyen pour s'endormir mensuel",
    sleep29: 'Domaines à améliorer',
    sleep30: 'Efficacité du sommeil',
    sleep31: 'Efficacité du sommeil mensuelle est',
    sleep32: 'Comment améliorer l’efficacité du sommeil ?',
    sleep33: 'Aperçus mensuels sur le sommeil',
    
    Expend: 'Activité',
    Expend1: 'Tendance de l’indice d’activité',
    Expend2: 'Tendance de l’indice d’activité',
    Expend3: 'L’indice d’activité est un indicateur pour évaluer votre état d’exercice, calculé en fonction de divers critères tels que le nombre de pas quotidien, la distance, les calories et le volume d’exercice.',
    Expend4: 'Indice moyen d’activité hebdomadaire est',
    Expend5: 'Vue d’ensemble de l’activité',
    Expend6: 'Les pas moyens sont',
    Expend7: ', la distance moyenne est',
     Expend8: 'km, calories sont',
    Expend9: ' kcal',
    Expend10: 'Type/Date',
    Expend11: 'Pas',
    Expend12: 'Kcal',
    Expend13: 'Distance',
    Expend14: 'Vous avez 5 jours pour atteindre l’objectif des pas',
    Expend15: ', vous avez 5 jours pour atteindre l’objectif calorique',
    Expend16: ', vous avez 5 jours pour atteindre l’objectif de distance',
    Expend17: 'Aperçus sur l’activité',
    
    Expend18: 'Indice d’activité',
    Expend19: 'La moyenne mensuelle de l’indice d’activité est',
    Expend20: 'Nombre moyen de pas',
    Expend21: 'La moyenne mensuelle du nombre de pas est',
    Expend22: 'Calories moyennes',
    Expend23: 'La moyenne mensuelle des calories est',
    Expend24: 'kcal',
    Expend25: 'Distance moyenne',
    Expend26: 'La moyenne mensuelle de la distance est',
    Expend27: 'km',
    Expend28: 'Comment améliorer les données d’activité ?',
    Expend29: 'Aperçus sur l’activité',

    Pressure: 'Équilibre',
    Pressure1: 'Tendance de l’indice d’équilibre',
    Pressure2: 'Tendance de l’indice d’équilibre',
    Pressure3: 'L’indice d’équilibre est un indicateur permettant d’évaluer votre état de stress, calculé sur la base de divers critères tels que le stress quotidien, la HRV, la réaction au stress et l’indice de récupération.',
    Pressure4: 'L’indice moyen de vitalité est',
    Pressure5: 'L’indice d’équilibre reste généralement stable, mais avec des fluctuations significatives, ce qui peut être lié à votre état émotionnel. Il est recommandé d’apprendre des techniques de gestion du stress, telles que la méditation et la respiration profonde, pour réguler les émotions et maintenir la santé physique et mentale.',
    Pressure6: 'Vue d’ensemble de l’équilibre',
    Pressure7: 'Le stress moyen est',
    Pressure8: 'La réaction au stress moyenne est',
    Pressure9: 'L’indice moyen de récupération est',
    Pressure10: 'Stress',
    Pressure11: 'Réaction au stress',
    Pressure12: 'Indice de récupération',
    Pressure13: 'Aperçus de l’équilibre',

    Pressure14: "Vos données sur l'équilibre améliorées",
    Pressure15: 'Indice de l’équilibre',
    Pressure16: 'La réaction mensuelle au stress est',
    Pressure17: 'Stress moyen',
    Pressure18: 'Le stress moyen mensuel est',
    Pressure19: 'Comment soulager le stress?',
    Pressure20: 'Aperçus sur l’équilibre et la récupération ?',
    
    Health: 'Santé cardiovasculaire',
    Health1: 'Votre tendance hebdomadaire du rythme cardiaque',
    Health2: 'La fréquence cardiaque moyenne est',
    Health3: 'bpm',
    Health4: 'Votre tendance hebdomadaire en oxygène sanguin',
    Health5: "La moyenne hebdomadaire de l'oxygène sanguin est",
    Health6: 'Votre risque hebdomadaire de diabète',
    Health7: 'Évaluation hebdomadaire du risque de diabète',
    Health8: 'Jours',
    Health9: ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'],
    
    Health10: 'Vos données de santé normales',
    Health11: 'Fréquence cardiaque moyenne',
    Health12: 'La fréquence cardiaque moyenne mensuelle est',
    Health13: 'Saturation moyenne en SpO2',
    Health14: 'La saturation moyenne mensuelle en SpO2 est',
    Health15: 'Vos données de santé anormales',
    Health16: 'Variabilité moyenne de la fréquence cardiaque',
    Health17: 'La variabilité moyenne mensuelle de la fréquence cardiaque est',
    Health18: 'ms',
    Health19: 'Comment améliorer la HRV ?',

   
  
 }
};



// WEBPACK FOOTER //
// ./src/lang/fr.js